/**
 * Indexing Run API Service (TASK-261 — Indexing Pipeline Visualizer)
 *
 * API client for the indexing-pipeline visualizer. Two endpoints:
 *   - getLatest()      → GET /api/v1/indexing-run/
 *       Lightweight latest run for the current organization (stage summaries,
 *       NO heavy artifacts). 404 if no run has happened yet.
 *   - getStage(order)  → GET /api/v1/indexing-run/stages/{order}/
 *       Heavy per-stage artifact (input/output/prompt/response), lazy-loaded
 *       when a stage is clicked.
 */
import apiClient from './client';
import type { IndexingRun, IndexingStageDetail } from '@/types/indexingRun';

export const indexingRunApi = {
  /**
   * Get the latest indexing run for the current organization.
   * Rejects with a 404 response when no run exists yet — callers should treat
   * a 404 as "no run" (placeholder), not a crash.
   */
  getLatest: async (): Promise<IndexingRun> => {
    const { data } = await apiClient.get<IndexingRun>('/api/v1/indexing-run/');
    return data;
  },

  /**
   * Get the heavy artifact of a single stage by its 0-based order.
   */
  getStage: async (order: number): Promise<IndexingStageDetail> => {
    const { data } = await apiClient.get<IndexingStageDetail>(
      `/api/v1/indexing-run/stages/${order}/`
    );
    return data;
  },
};

export default indexingRunApi;
